import React, { FC, useRef, useState } from 'react';

import cn from 'classnames';
import { t } from 'ttag';

import Icon from '../ui/icon/icon';

import { useOnClickOutside } from '../../lib/reactHelpers/hooks';
import { MAIL_URL, PHONE_URL, TELEGRAM_URL, VIBER_URL } from './constants';

import SvgClose from './images/close.svg';
import SvgMail from './images/mail.svg';
import SvgMessage from './images/message.svg';
import SvgPhone from './images/phone.svg';
import SvgTelegram from './images/telegram.svg';
import SvgViber from './images/viber.svg';

import css from './MessengersButton.css';

const messengerList = [
    {
        name: 'Telegram',
        icon: SvgTelegram,
        url: TELEGRAM_URL,
    },
    {
        name: 'Viber',
        icon: SvgViber,
        url: VIBER_URL,
    },
    {
        name: t`Надіслати e-mail`,
        icon: SvgMail,
        url: MAIL_URL,
    },
    {
        name: t`Зателефонувати`,
        icon: SvgPhone,
        url: PHONE_URL,
    },
];

const MessengersButton: FC<React.PropsWithChildren<unknown>> = () => {
    const blockRef = useRef<HTMLDivElement>(null);
    const [isExpanded, setIsExpanded] = useState(false);

    const handleTooltipClick = (e: React.MouseEvent<HTMLSpanElement>) => {
        e.preventDefault();
    };

    const handleButtonClick = () =>
        setIsExpanded((_isExpanded) => !_isExpanded);

    useOnClickOutside(blockRef, () => {
        if (isExpanded) {
            setIsExpanded(false);
        }
    });

    return (
        <div
            className={cn(css.root, {
                [css.rootOpened]: isExpanded,
            })}
            ref={blockRef}
        >
            <div
                className={cn(css.baseButton, css.mainButton)}
                onClick={handleButtonClick}
            >
                <div className={cn(css.baseIcon, css.messageIcon)}>
                    <Icon glyph={SvgMessage} />
                </div>
                <div className={cn(css.baseIcon, css.closeIcon)}>
                    <Icon glyph={SvgClose} />
                </div>
            </div>
            {messengerList.map((item) => (
                <a
                    key={item.url}
                    href={item.url}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className={cn(css.baseButton, css.linkButton)}
                >
                    <Icon glyph={item.icon} />
                    <span className={css.tooltip} onClick={handleTooltipClick}>
                        {item.name}
                    </span>
                </a>
            ))}
        </div>
    );
};

export default MessengersButton;
